export const CHANNEL_LIST = 'CHANNELS/list';
export const CHANNEL_PAGER = 'CHANNELS/pager';
export const CHANNEL_FILTER = 'CHANNELS/filter';
export const CHANNEL_ITEM = 'CHANNELS/item';

export const CHANNEL_BRANCH_LIST = 'CHANNELS/branch_list';
export const CHANNEL_BRANCH_PAGER = 'CHANNELS/branch_pager';
export const CHANNEL_BRANCH_FILTER = 'CHANNELS/branch_filter';
export const CHANNEL_BRANCH_ITEM = 'CHANNELS/branch_item';

export const COUNT_CARD = 'CHANNELS/count_card';
